import axios from "axios";

export const getUkData = async (query) => {
  query = query.replaceAll("-", " ");
  query = query.replaceAll("'", "");
  query = query.replaceAll(",", " ");
  query = query.replaceAll("&", " ");
  const params = {
    q: query,
  };
  try {
    let data = await axios.get(
      `${process.env.REACT_APP_COMPANY_LOOKUP_BASE_URL}/searchUkCompany`,
      {
        params,
      }
    );

    if (!data) throw new Error(`Data for keyword ${query} not found`, 404);
    data = data.data.items;
    if (data === "No Search result found") return [];

    const newData = data.filter(
      (item) => item.company_number || item.external_registration_number
    );

    const finalData = [];
    for (const item of newData) {
      const {
        title,
        company_number,
        address_snippet,
        external_registration_number,
      } = item;

      const obj = {};
      Object.assign(
        obj,
        title && { companyName: title },
        company_number && { companyNumber: company_number },
        address_snippet && { companyAddress: address_snippet },
        external_registration_number && {
          external_registration_number: external_registration_number,
        }
      );
      const arr = Object.keys(obj);

      if (arr.length === 0) {
        return [];
      }
      finalData.push(obj);
    }
    return finalData;
  } catch (error) {
    return error;
  }
};
